import { createAction } from 'redux-actions';
import { actionKey } from './constants';
// for internal use - this has all duperbrowse-handled locations
export var duperbrowseHistoryChanged = createAction("".concat(actionKey, ".HISTORY_CHANGED.DUPERBROWSE"), function (location, action) { return ({
    location: location,
    action: action,
}); });
// for general use - this has all unhandled history updates
// (ie. anything not handled by duperbrowse)
export var historyChanged = createAction("".concat(actionKey, ".HISTORY_CHANGED"), function (location, action) { return ({
    location: location,
    action: action,
}); });
//# sourceMappingURL=actions.js.map